var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0172 16.9201V19.9201C22.0183 20.1986 21.9612 20.4743 21.8497 20.7294C21.7381 20.9846 21.5745 21.2137 21.3692 21.402C21.164 21.5902 20.9217 21.7336 20.6579 21.8228C20.3941 21.912 20.1145 21.9452 19.8372 21.9201C16.76 21.5857 13.8042 20.5342 11.2072 18.8501C8.79098 17.3148 6.74249 15.2663 5.20715 12.8501C3.51713 10.2413 2.4654 7.27109 2.13715 4.1801C2.11216 3.90356 2.14503 3.62486 2.23365 3.36172C2.32228 3.09859 2.46472 2.85679 2.65192 2.65172C2.83911 2.44665 3.06696 2.28281 3.32094 2.17062C3.57493 2.05843 3.84949 2.00036 4.12715 2.0001H7.12715C7.61246 1.99532 8.08294 2.16718 8.45091 2.48363C8.81888 2.80008 9.05923 3.23954 9.12715 3.7201C9.25378 4.68016 9.4886 5.62282 9.82715 6.5301C9.9617 6.88802 9.99082 7.27701 9.91106 7.65098C9.8313 8.02494 9.64602 8.36821 9.37715 8.6401L8.10715 9.9101C9.53071 12.4136 11.6036 14.4865 14.1072 15.9101L15.3772 14.6401C15.649 14.3712 15.9923 14.1859 16.3663 14.1062C16.7402 14.0264 17.1292 14.0556 17.4872 14.1901C18.3944 14.5286 19.3371 14.7635 20.2972 14.8901C20.7829 14.9586 21.2266 15.2033 21.5437 15.5776C21.8608 15.9519 22.0293 16.4297 22.0172 16.9201Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.9badf717908b1b8d440b850b0683530e.svg";
export { ForwardRef as ReactComponent };